import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import MuiContainer, { ContainerProps } from '@mui/material/Container';
import MuiDivider, { DividerProps } from '@mui/material/Divider';
import { spacing, SpacingProps } from '@mui/system';
import { TSFixMe } from '@yi/core';

import { cloudyBlue, black80 } from '~/styles';

interface Props {
  color?: string;
}

const DividerWrapper = styled(Box)`
  ${spacing}
  padding: 1px 0;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof Box>>>;

const Container = styled(MuiContainer)`
  padding: 1px 0;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof MuiContainer>>>;

const BaseMuiDivider: React.FC<React.ComponentProps<typeof MuiDivider>> = props => (
  <MuiDivider {...props} />
);
const Divide = styled(BaseMuiDivider)<Props>`
  ${props =>
    props.color
      ? css`
          background-color: ${props.color};
        `
      : css`
          background-color: ${cloudyBlue};
        `}
`;

export const Divider: React.FC<
  PropsWithChildren<Partial<ContainerProps> & DividerProps & SpacingProps & Props>
> = ({ color, children, ...props }) => (
  <DividerWrapper {...(props as TSFixMe)}>
    <Container maxWidth="xl">
      <Divide color={color || black80} />
      {children}
    </Container>
  </DividerWrapper>
);
